var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "toggle-tip",
      class: { "is-active": _vm.isActive },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.hide.apply(null, arguments)
        },
      },
    },
    [
      _c("span", {
        ref: "open",
        staticClass: "toggle-tip__open",
        attrs: {
          "aria-describedby": _vm.isActive ? `${_vm.id}-dialog` : false,
          role: "button",
          tabindex: "0",
        },
        domProps: { innerHTML: _vm._s(_vm.open) },
        on: {
          click: _vm.show,
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
            return _vm.show.apply(null, arguments)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            )
              return null
            $event.preventDefault()
            return _vm.show.apply(null, arguments)
          },
          mouseenter: _vm.onMouseEnter,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "toggle-tip__modal",
          style: _vm.styles,
          on: { click: _vm.hide },
        },
        [
          _c("div", { staticClass: "toggle-tip__container" }, [
            _c(
              "div",
              {
                ref: "dialog",
                staticClass: "toggle-tip__dialog",
                attrs: {
                  id: `${_vm.id}-dialog`,
                  "aria-labelledby": `${_vm.id}-title`,
                  "aria-hidden": !_vm.isActive,
                  role: "dialog",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "toggle-tip__guard",
                  attrs: { tabindex: "0" },
                  on: { focus: _vm.focusClose },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    ref: "close",
                    staticClass: "toggle-tip__close",
                    attrs: { type: "button" },
                    on: { click: _vm.hide },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 13 13",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M7.881 6.501l4.834-4.834c.38-.38.38-1.001 0-1.381s-1.001-.38-1.381 0L6.5 5.12 1.666.285c-.38-.38-1.001-.38-1.381 0s-.38 1.001 0 1.381L5.119 6.5.285 11.334c-.38.38-.38 1.001 0 1.381s1.001.38 1.381 0L6.5 7.881l4.834 4.834c.38.38 1.001.38 1.381 0s.38-1.001 0-1.381z",
                            fill: "currentColor",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "sr-only" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.close) + "\n          "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "toggle-tip__title h4",
                  attrs: { id: `${_vm.id}-title` },
                  domProps: { innerHTML: _vm._s(_vm.title) },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "toggle-tip__description wysiwyg",
                  domProps: { innerHTML: _vm._s(_vm.description) },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "toggle-tip__guard",
                  attrs: { tabindex: "0" },
                  on: { focus: _vm.focusClose },
                }),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }